import { useEffect } from "react";
import { CHECK_INTERVAL, IDLE_TIMEOUT } from "utils/constant";

function IdleManager() {
  const channel = new BroadcastChannel("activityChannel");

  useEffect(() => {
    let lastActivity = Date.now();

    const updateActivity = () => {
      lastActivity = Date.now();
      channel.postMessage({ type: "USER_ACTIVITY", timestamp: lastActivity });
    };

    const checkIdleState = () => {
      const now = Date.now();
      const allTabsIdle = now - lastActivity >= IDLE_TIMEOUT;

      if (allTabsIdle) {
        // Notify all tabs and parent app
        channel.postMessage({ type: "ALL_TABS_IDLE" });
      }
    };

    // Track user activity
    window.addEventListener("mousemove", updateActivity);
    window.addEventListener("keypress", updateActivity);
    window.addEventListener("click", updateActivity);

    // Broadcast initial activity state
    updateActivity();

    // Periodically check idle state
    const interval = setInterval(checkIdleState, CHECK_INTERVAL);

    // Handle broadcast messages
    channel.onmessage = (event) => {
      if (event.data.type === "USER_ACTIVITY") {
        lastActivity = Math.max(lastActivity, event.data.timestamp);
      }
    };

    return () => {
      clearInterval(interval);
      window.removeEventListener("mousemove", updateActivity);
      window.removeEventListener("keypress", updateActivity);
      window.removeEventListener("click", updateActivity);
      channel.close();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}

export default IdleManager;
